/// <amd-module name="Search/WorkItem/Constants" />
import * as Resources from "Search/WorkItem/Resources";
import { WorkItemFieldType } from "Search/LegacyWebApi/Contracts/Workitem";

export namespace Ref {
    export const assignedTo = "system.assignedto";
    export const title = "system.title";
    export const id = "system.id";
    export const state = "system.state";
    export const tags = "system.tags";
    export const type = "system.workitemtype";
    export const changedDate = "system.changeddate";
    export const createdDate = "system.createddate";
}

export namespace SortActionIds {
    export const AssignedTo = Ref.assignedTo;
    export const ChangedDate = Ref.changedDate;
    export const CreatedDate = Ref.createdDate;
    export const ID = Ref.id;
    export const State = Ref.state;
    export const Tags = Ref.tags;
    export const Title = Ref.title;
    export const WorkItemType = Ref.type;
    export const Relevance = "relevance";
    export const Ascending = "asc";
    export const Descending = "desc";
}

export const FieldType: { [key: string]: WorkItemFieldType } = {
    [Ref.assignedTo]: WorkItemFieldType.Identity,
    [Ref.changedDate]: WorkItemFieldType.DateTime,
    [Ref.createdDate]: WorkItemFieldType.DateTime,
    [Ref.id]: WorkItemFieldType.Integer,
    [Ref.state]: WorkItemFieldType.String,
    [Ref.tags]: WorkItemFieldType.String,
    [Ref.title]: WorkItemFieldType.String,
    [Ref.type]: WorkItemFieldType.String
}

export namespace CustomerIntelligenceConstants {
    export const TTIScenarioName = "WorkItemSearchTTIScenario";
    export const TabSwitchScenarioName = "WorkItemSearchTabSwitchScenario";
    export const SubsequentSearchScenarioName = "WorkItemSearchTTIScenario";
    export const RedirectedPreviewScenario = "RedirectedWorkItemSearchPreviewScenario";
    export const PreviewOnTabSwitchScenario = "WorkItemSearchPreviewOnTabSwitchScenario";
    export const QueryResultScenarioName = "WorkItemSearchQueryResultsScenario";
    export const EntityName = "WorkItem";
    export const SearchStarted = "SearchStarted";
    export const ResultsLoaded = "ResultsLoaded";
    export const FilterPaneVisibilityChanged = "FilterPaneVisibilityChanged";
    export const ItemChanged = "ItemChanged";
    export const SortOptionChanged = "SortOptionChanged";
    export const PreviewOrientationChanged = "PreviewOrientationChanged";
    export const PreviewMessageBanner = "PreviewMessageBanner";
    export const ZeroData = "ZeroData";
    export const NotificationBanner = "NotificationBanner";
    export const SearchHelpFilterActivated = "SearchHelpFilterActivated";
    export const SearchInNewTab = "SearchInNewTab";
    export const SearchTextRemoved = "SearchTextRemoved";
    export const AccountLinkClicked = "AccountLinkClicked";
    export const AccountButtonClicked = "AccountButtonClicked";
    export const FeedbackLinkClicked = "FeedbackLinkClicked";
    export const FeedbackMailLinkClicked = "FeedbackMailLinkClicked";
    export const FilterResetClicked = "FilterResetClicked";
    export const FiltersUpdated = "FiltersUpdated";
    export const LaunchPoint = "LaunchPoint";
    export const L2SearchBarFocused = "L2SearchBarFocused";
    export const OrgSearchNavigationFromWorkItemSearchPageSource = "tfs.Search.workItem";
    export const WorkItemOpenForm = "OpenForm";
	export const ResultsFetchedFromSeedDataService = "ResultsFetchedFromSeedDataService";
}

export namespace IndexingErrorCodeConstants {
    export const AccountIsBeingIndexed = "AccountIsBeingIndexed";
    export const AccountIsBeingReindexed = "AccountIsBeingReindexed";
    export const AccountIsBeingOnboarded = "AccountIsBeingOnboarded";
}

export namespace PreviewOrientationActionIds {
    export const Off = "off";
    export const Right = "right";
    export const Bottom = "bottom";
}

export namespace FilterKeys {
    export const ProjectFiltersKey: string = "Projects";
    export const WorkItemTypesFiltersKey: string = "Work Item Types";
    export const StateFiltersKey: string = "States";
    export const AssignedToFiltersKey: string = "Assigned To";
    export const AreaPathsFilterKey: string = "Area Paths";
}

export namespace PreferenceConstants {
    export const SplitterFixedSizeKey = "vss-search-web/workitem/splitterFixedSize";
    export const PreviewOrientationKey = "vss-search-web/workitem/previewOrientation";
}

export namespace ResultsViewConstants {
    export const WhiteSpaceRegex = /(\s+)/g;
    export const HashGlobalRegex = /#/g;
    export const HitHighlightLightHtmlEncodedStartTagRegex = /(&lt;highlighthit&gt;)/gi;
    export const HitHighlightLightHtmlEncodedEndTagRegex = /(&lt;\/highlighthit&gt;)/gi;
    export const AvatarAliasHitRegex = /<<highlighthit\s*[\/]?>([\w\.]+)<\s*[\/]highlighthit>@[<>\/\w\.]+>/;
    export const HighlightRegex = /(<highlighthit\s*[\/]?>)|(<\s*[\/]highlighthit>)/gi;
    export const HighlightStartTag = "<highlighthit>";
    export const HighlightEndTag = "</highlighthit>";
    export const Ellipsis = "...";
    export const MetadataFields = [
        Ref.state,
        Ref.id,
        Ref.assignedTo,
        Ref.tags,
        Ref.title,
        Ref.type];

    export const FieldNameToDisplayName: { [key: string]: string } = {
        "history": Resources.Discussion
    };
    export const AvatarWidth = 130;
    export const AvatarColonWidth = 160;
    export const SnippetColumnWidth = 100;
    export const AvatarColumnHeight = 16;
}

export namespace FeatureFlagConstants {
    export const InfiniteScroll = "WebAccess.Search.WorkItem.InfiniteScroll";
    export const DisableAggregations: string = "WebAccess.Search.WorkItem.DisableAggregations";
    export const EnableTagsSortingForWorkitem = "WebAccess.Search.WorkItem.EnableTagsSorting";
}

export namespace FeatureConstants {
    export const NewBoardsHubs: string = "ms.vss-work-web.new-boards-hub-feature";
}

export const EntityTypeUrlParam = "workitem";
export const WorkItemRoute = "ms.vss-work-web.work-items-form-route-with-id";
export const WorkItemSearchTakeResults = 50;
export const WorkItemSearchInfiniteScrollTakeResults = 25;
export const WorkItemSearchMaxSkipOrTakeResults = 1000;
export const WorkItemSearchLoadMoreTakeResults = 20;
export const FeedbackMailToLinkFormat =
    "mailto:vstssearch@microsoft.com?Subject=Feedback on Azure DevOps Services Work item Search [Reference ID: {0}]";
export const DevOpsFeedbackMailToLinkFormat =
    "https://developercommunity.visualstudio.com/report?space=21&version=NONE&azActivityId={0}";
export const LearnMoreLink = "https://go.microsoft.com/fwlink/?linkid=859316";
export const WorkItemSearchPageDataProviderContributionId = "ms.vss-workitem-search.workitem-search-page-viewmodel-data-provider";
export const WorkItemSearchOnPremPageDataProviderContributionId = "ms.vss-workitem-searchonprem.workitem-search-page-viewmodel-data-provider";